import api from "./api";

const state = {
  // StarContentsList
  starContentsList: [],
  starContentsCount: 0,

  // BookshelfShare
  bookshelfShareUrl: ""
};

// getters
const getters = {
  getOnWallBookCount: state => {
    return state.starContentsList.filter(
      starContents => starContents.isOnWall && !starContents.isPanel
    ).length;
  },
  getOnWallPanelCount: state => {
    return state.starContentsList.filter(
      starContents => starContents.isOnWall && starContents.isPanel
    ).length;
  }
};

// actions
const actions = {
  async postStar(context, params) {
    try {
      const res = await api.postStar(params);
      return res.status;
    } catch (error) {
      return error;
    }
  },
  async deleteStar(context, params) {
    try {
      const res = await api.deleteStar(params);
      return res.status;
    } catch (error) {
      return error;
    }
  },
  async deleteFromStarContentsList(context, params) {
    try {
      const res = await api.deleteStar({ identificationCode: params });
      context.commit("releaseStarContents", params);
      return res.status;
    } catch (error) {
      context.commit("common/setError", error, { root: true });
    }
  }
};

// mutations
const mutations = {
  updateStarContentsList(state, payload) {
    state.starContentsList = [...payload];
    state.starContentsCount = state.starContentsList.length;
  },
  releaseStarContents(state, identificationCode) {
    state.starContentsList = [
      ...state.starContentsList.filter(
        starContents => starContents.identificationCode !== identificationCode
      )
    ];
    state.starContentsCount = state.starContentsList.length;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
